function normalize(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

export function searchHub(rawQuery, items = []) {
  const query = normalize(rawQuery);
  if (!query) return [];

  const terms = query.split(/\s+/).filter(Boolean);

  return items
    .map((item) => {
      const title = normalize(item.title);
      const keywords = normalize(
        Array.isArray(item.keywords)
          ? item.keywords.join(" ")
          : item.keywords
      );
      const description = normalize(item.description);
      const type = normalize(item.type);

      let score = 0;

      terms.forEach((term) => {
        if (title === term) score += 30;
        else if (title.startsWith(term)) score += 20;
        else if (title.includes(term)) score += 12;

        if (keywords.includes(term)) score += 7;
        if (description.includes(term)) score += 3;
        if (type.includes(term)) score += 2;
      });

      return {
        ...item,
        score,
      };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      return a.title.localeCompare(b.title);
    })
    .slice(0, 100);
}